import React, { memo } from "react";
import {
  Button,
  DrawerCloseButton,
  DrawerHeader,
  HStack,
  Text,
} from "@chakra-ui/react";
import colors from "app/colors";
import { useOverlay } from "modules/providers/overlay-provider";

interface IProps {
  title?: string | null;
  onClearClicked?: () => void;
  icon?: React.ReactNode;
}

//avoiding name collison with DrawerHeader from chakra
const DrawerTopHeader: React.FC<IProps> = ({ title, onClearClicked, icon }) => {
  const { closeDrawer } = useOverlay();

  return (
    <DrawerHeader px={3} pb={0}>
      <HStack
        pb={3}
        w="full"
        borderBottomWidth={1}
        borderBottomColor={colors.grayPrimary}
      >
        <DrawerCloseButton size="lg" position="unset" onClick={closeDrawer} />
        <Text
          fontWeight={700}
          fontFamily="Outfit"
          fontSize={26}
          flex={1}
          textAlign="center"
          noOfLines={1}
        >
          {title}
        </Text>
        {onClearClicked && (
          <Button
            variant="outline"
            iconSpacing={1.5}
            px={2}
            py={1}
            h="fit-content"
            borderColor={colors.gray40}
            color={colors.gray40}
            onClick={onClearClicked}
          >
            Clear
          </Button>
        )}
        {icon}
      </HStack>
    </DrawerHeader>
  );
};

export default memo(DrawerTopHeader);
